import styled from "styled-components";
import { PRIMARY_RED } from "../../constants/color";

export const RequiredBadge: React.FC = () => {
  return <StyledBadge>必須</StyledBadge>;
};

const StyledBadge = styled.span`
  font-size: 11px;
  font-weight: 400;
  line-height: 100%;
  color: ${PRIMARY_RED};
  border-radius: 8px;
`;
